/**
 * 将选中的本地文件读取为 dataUrl
 * @param {File | Blob} file 文件
 * @returns {Promise<string>}
 */
export function readFileAsDataURL (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = function (e) {
      resolve(/** @type {string} */(e.target.result))
    }
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

/**
 * 将 dataUrl 转化为 blob
 * @param {string} dataURL
 * @returns {Blob}
 */
export function dataURLtoBlob (dataURL) {
  const byteString = atob(dataURL.split(',')[1])
  const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0]
  const ab = new ArrayBuffer(byteString.length)
  const ia = new Uint8Array(ab)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ab], { type: mimeString })
}
